import React from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AspectRatioId } from "../../../cores/videoGen/types";
import cn from "classnames";

const RATIOS: { id: AspectRatioId; icon: "portrait" | "rectangle" | "square"; labelId: string }[] = [
  { id: "portrait", icon: "portrait", labelId: "app.videoGen.aspect.portrait" },
  { id: "landscape", icon: "rectangle", labelId: "app.videoGen.aspect.landscape" },
  { id: "square", icon: "square", labelId: "app.videoGen.aspect.square" },
];

interface AspectRatioSelectorProps {
  value: AspectRatioId;
  onChange: (id: AspectRatioId) => void;
}

export function AspectRatioSelector({ value, onChange }: AspectRatioSelectorProps) {
  const intl = useIntl();

  return (
    <div className="video-gen-aspect-ratio">
      {RATIOS.map(({ id, icon, labelId }) => (
        <button
          key={id}
          type="button"
          className={cn("btn video-gen-aspect-ratio__btn", {
            "video-gen-aspect-ratio__btn--active": value === id,
          })}
          onClick={() => onChange(id)}
        >
          <span className={`video-gen-aspect-ratio__icon video-gen-aspect-ratio__icon--${icon}`} />
          <span className="ml-2">{intl.formatMessage({ id: labelId })}</span>
        </button>
      ))}
    </div>
  );
}
